import { useRouter } from 'next/router';
import AIDriven from '../comps/AIDriven';
import BackupPriority from '../comps/BackupPriority';
import BannerA from '../comps/BannerA';
import Brands from '../comps/Brands';
import C from '../comps/C';
import Charts from '../comps/Charts';
import CutCosts from '../comps/CutCosts';
import D from '../comps/D';
import Developer from '../comps/Developer';
import DownloadApp from '../comps/DownloadApp';
import FixProcess from '../comps/FixProcess';
import Footnotes from '../comps/Footnotes';
import ListA from '../comps/ListA';
import Nav from '../comps/Nav';
import Safety from '../comps/Safety';
import SmartBackup1 from '../comps/SmartBackup1';
import SmartBackup2 from '../comps/SmartBackup2';
import SmartInsights from '../comps/SmartInsights';
import TabImg from '../comps/TabImg';
import Table from '../comps/Table';
import BrandsEu from '../compsEu/BrandsEu';
import CEu from '../compsEu/CEu';
import FixProcessEu from '../compsEu/FixProcessEu';
import ListAEu from '../compsEu/ListAEu';
import TabImgEu from '../compsEu/TabImgEu';
import SubscriptionPlan from '../compsEu/SubscriptionPlan';
import styles from './index.module.scss';

export default function StatusA() {
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'es', 'fr', 'it'].includes(locale);
    const RenderPageContent = () => {
        if (IS_NA_SITES) {
            return (
                <>
                    <Nav />
                    <BannerA />
                    <ListA />
                    <FixProcess />
                    <div className="range1">
                        <C />
                        <D />
                        <Brands />
                    </div>
                    <div className="range2">
                        <AIDriven />
                        <SmartInsights />
                    </div>
                    <div className="range3">
                        <SmartBackup1 />
                        <SmartBackup2 />
                        <BackupPriority />
                    </div>
                    <div className="range4">
                        <CutCosts />
                        <TabImg />
                        <Charts />
                    </div>
                    <div className="range5">
                        <Safety />
                        <Table />
                        <Developer />
                        <DownloadApp />
                    </div>
                    <Footnotes />
                </>
            );
        }
        if (IS_EU_SITES) {
            return (
                <>
                    <Nav />
                    <BannerA />
                    <ListAEu />
                    <FixProcessEu />
                    <div className="range1">
                        <AIDriven />
                        <SmartInsights />
                    </div>
                    {/* 2 */}
                    <div className="range2">
                        <CutCosts />
                        <TabImgEu />
                        <Charts />
                    </div>
                    {/* 3 */}
                    <div className="range3">
                        <CEu />
                        <D />
                        <BrandsEu />
                    </div>
                    <div className="range4">
                        <Safety />
                        {/* <Table /> */}
                        <SubscriptionPlan />
                        <Developer />
                        <DownloadApp />
                    </div>
                    <Footnotes />
                </>
            );
        }
        return <></>;
    };
    return (
        <div className={`${styles.StatusA} page-oasis`}>
            <RenderPageContent />
        </div>
    );
}
